var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleplayBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 171.965,
    height: 50.953,
    viewBox: "0 0 171.965 50.953",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.003,
    x2: 0.5,
    y2: 0.993,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#267caf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286,
    stopColor: "#4a92b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767,
    stopColor: "#79bcba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88cebc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.638,
    y1: 0.141,
    x2: 0.339,
    y2: 0.948,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f48879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119,
    stopColor: "#f5907a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    stopColor: "#fbb777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdc874"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.866,
    y1: 0.172,
    x2: 0.048,
    y2: 1.029,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb413d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#d94452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#af487a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#954b92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#894a9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.106,
    y1: 0.073,
    x2: 0.888,
    y2: 0.85,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#54c0ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dde79a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Googleplay_badge",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8",
    "data-name": "Trazado 8",
    d: "M327.483,348.406a4.881,4.881,0,0,1-4.881,4.88H162.686a4.887,4.887,0,0,1-4.893-4.88V309.489a4.893,4.893,0,0,1,4.893-4.886H322.6a4.886,4.886,0,0,1,4.886,4.885h0v38.917Z",
    transform: "translate(-156.659 -303.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9",
    "data-name": "Trazado 9",
    d: "M317.683,349.509H157.772a6.028,6.028,0,0,1-6.027-6.015V304.578a6.031,6.031,0,0,1,6.027-6.022h159.91a6.034,6.034,0,0,1,6.027,6.022v38.916a6.027,6.027,0,0,1-6.026,6.015Z",
    transform: "translate(-151.745 -298.556)",
    fill: "#a6a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10",
    "data-name": "Trazado 10",
    d: "M327.483,348.406a4.881,4.881,0,0,1-4.881,4.88H162.686a4.887,4.887,0,0,1-4.893-4.88V309.489a4.893,4.893,0,0,1,4.893-4.886H322.6a4.886,4.886,0,0,1,4.886,4.885h0v38.917Z",
    transform: "translate(-156.659 -303.469)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11",
    "data-name": "Trazado 11",
    d: "M665.48,298.556H579.827l33.549,50.953h52.1a6.031,6.031,0,0,0,6.027-6.019V304.578A6.033,6.033,0,0,0,665.48,298.556Z",
    transform: "translate(-499.542 -298.556)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5",
    "data-name": "Grupo 5",
    transform: "translate(18.009 9.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12",
    "data-name": "Trazado 12",
    d: "M443.368,362.88a3.393,3.393,0,0,1-.872,2.491,3.875,3.875,0,1,1-2.74-6.6,3.315,3.315,0,0,1,1.495.374,2.711,2.711,0,0,1,1.121.872l-.623.623a2.322,2.322,0,0,0-1.993-.872,2.478,2.478,0,0,0-1.993.872,3.007,3.007,0,0,0,0,4.234,3.207,3.207,0,0,0,1.993.872,2.731,2.731,0,0,0,2.117-.872,2.062,2.062,0,0,0,.623-1.495h-2.74v-1h3.612v.5Zm5.729-3.114h-3.363v2.366h3.114V363h-3.114v2.366H449.1v1h-4.359v-7.473H449.1Zm4.11,6.6h-1v-6.6h-2.117v-.872h5.231v.872h-2.117Zm5.729,0v-7.473h1v7.473Zm5.231,0h-1v-6.6h-2.117v-.872h5.107v.872h-2.117v6.6Zm11.832-1a3.909,3.909,0,1,1,1.121-2.74A3.662,3.662,0,0,1,476,365.371Zm-4.733-.623a2.94,2.94,0,0,0,1.993.872,2.478,2.478,0,0,0,1.993-.872,3,3,0,0,0,.872-2.117,2.565,2.565,0,0,0-.872-2.117,2.939,2.939,0,0,0-1.993-.872,2.478,2.478,0,0,0-1.993.872,3,3,0,0,0-.872,2.117A2.566,2.566,0,0,0,471.267,364.748Zm7.224,1.619v-7.473h1.121l3.612,5.854v-5.854h1v7.473h-1l-3.861-6.1v6.1Z",
    transform: "translate(-400.613 -357.407)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13",
    "data-name": "Trazado 13",
    d: "M467.53,423.724a5.24,5.24,0,0,0-5.356,5.355,5.316,5.316,0,0,0,5.356,5.356,5.24,5.24,0,0,0,5.355-5.356A5.167,5.167,0,0,0,467.53,423.724Zm0,8.469a3.249,3.249,0,0,1,0-6.476,3.017,3.017,0,0,1,2.989,3.238A3.092,3.092,0,0,1,467.53,432.193Zm-11.583-8.469a5.24,5.24,0,0,0-5.356,5.355,5.316,5.316,0,0,0,5.356,5.356,5.24,5.24,0,0,0,5.356-5.356A5.167,5.167,0,0,0,455.947,423.724Zm0,8.469a3.249,3.249,0,0,1,0-6.476,3.017,3.017,0,0,1,2.989,3.238A3.092,3.092,0,0,1,455.947,432.193Zm-13.825-6.85v2.242h5.356a4.71,4.71,0,0,1-1.246,2.865,5.512,5.512,0,0,1-4.11,1.619,5.8,5.8,0,0,1-5.854-5.978,5.875,5.875,0,0,1,5.854-5.978,6.176,6.176,0,0,1,4.11,1.619l1.619-1.619a7.981,7.981,0,0,0-5.6-2.242,8.221,8.221,0,1,0,0,16.44,7.167,7.167,0,0,0,5.729-2.367,7.5,7.5,0,0,0,1.993-5.231,4.671,4.671,0,0,0-.125-1.37Zm56.545,1.744a4.839,4.839,0,0,0-4.484-3.363,5.016,5.016,0,0,0-4.982,5.355,5.212,5.212,0,0,0,5.231,5.356,5.109,5.109,0,0,0,4.359-2.366l-1.744-1.245a3.036,3.036,0,0,1-2.616,1.495,2.7,2.7,0,0,1-2.615-1.619l7.1-2.989-.249-.623Zm-7.224,1.744a3.025,3.025,0,0,1,2.74-3.114,2.2,2.2,0,0,1,1.993,1.121l-4.733,1.993Zm-5.854,5.106h2.366V418.368H485.59Zm-3.736-9.092a4.1,4.1,0,0,0-2.865-1.246,5.352,5.352,0,0,0-5.106,5.355,5.157,5.157,0,0,0,5.106,5.231,3.576,3.576,0,0,0,2.74-1.245h.125v.747c0,1.993-1.121,3.114-2.865,3.114a2.767,2.767,0,0,1-2.616-1.868l-1.993.872a5.138,5.138,0,0,0,4.733,3.114c2.74,0,4.982-1.619,4.982-5.48v-9.466h-2.242v.872Zm-2.74,7.348a3.249,3.249,0,0,1,0-6.476,3.263,3.263,0,0,1,0,6.476Zm30.39-13.825h-5.6v15.569h2.366v-5.854H509.5a4.863,4.863,0,1,0,0-9.715Zm.124,7.473h-3.363v-5.356h3.363a2.736,2.736,0,0,1,2.74,2.616,2.85,2.85,0,0,1-2.74,2.74Zm14.323-2.242a4.187,4.187,0,0,0-4.11,2.366l2.117.872a2.2,2.2,0,0,1,2.117-1.121,2.341,2.341,0,0,1,2.491,1.992v.125a4.938,4.938,0,0,0-2.366-.623c-2.242,0-4.484,1.246-4.484,3.487a3.649,3.649,0,0,0,3.861,3.487,3.5,3.5,0,0,0,2.989-1.495h.125v1.246h2.242v-5.978a4.713,4.713,0,0,0-4.982-4.359Zm-.249,8.594c-.747,0-1.868-.374-1.868-1.37,0-1.245,1.37-1.619,2.491-1.619a4.81,4.81,0,0,1,2.117.5A2.9,2.9,0,0,1,523.7,432.193Zm13.078-8.22-2.615,6.725h-.125l-2.74-6.725h-2.491l4.11,9.466-2.366,5.231h2.366l6.352-14.7Zm-20.924,9.964h2.366V418.368h-2.366Z",
    transform: "translate(-398.994 -405.423)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4",
    "data-name": "Grupo 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14",
    "data-name": "Trazado 14",
    d: "M248.269,353.686a2.435,2.435,0,0,0-.5,1.744v27.525a2.464,2.464,0,0,0,.623,1.744l.125.125,15.444-15.444v-.249Z",
    transform: "translate(-247.771 -353.277)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15",
    "data-name": "Trazado 15",
    d: "M338.546,419.393l-5.107-5.107v-.374l5.107-5.107.124.125,6.1,3.487c1.744,1,1.744,2.616,0,3.612Z",
    transform: "translate(-317.372 -398.059)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16",
    "data-name": "Trazado 16",
    d: "M271.227,441.929,266,436.7l-15.569,15.569c.623.623,1.495.623,2.616.125l18.184-10.462",
    transform: "translate(-249.929 -420.72)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17",
    "data-name": "Trazado 17",
    d: "M271.227,362.25l-18.184-10.337a2.019,2.019,0,0,0-2.616.125L266,367.481l5.231-5.231Z",
    transform: "translate(-249.929 -351.503)",
    fill: "url(#linear-gradient-4)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplayBadge);
export default __webpack_public_path__ + "static/media/Googleplay_badge.1fc1618a820049398757485b216ce9ac.svg";
export { ForwardRef as ReactComponent };